import { Component } from '@angular/core';
import { BootstrapSizeComponent } from '../../../../parts/development/bootstrap-size.component';

@Component({
  selector: 'ms-footer',
  imports: [BootstrapSizeComponent],
  templateUrl: './footer.component.html'
})
export class FooterComponent {

}
